import React, { useEffect, useState } from "react";
import LoadingLogoPage from "../../loadingPage/loadingPage";
import { useAuth } from "../../../context/API_Client";
import { useNavigate } from "react-router";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import BoxPayGrid from "../../BoxPayGrid";
import RoleSchema from "./rolesSchema";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import { convertIsoToGivenDateFormat } from "../../utils/utils";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../../constants/brandings";

export default function Roles({ operationPermissions }) {
  const { getAllRoles, deleteRoleById, merchantSettings } = useAuth();
  const navigate = useNavigate();
  const [rolesData, setRolesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [toggleDialog, setToggleDialog] = useState(false);
  const [tableActionValue, setTableActionValue] = useState("");
  const [timeZone, setTimeZone] = useState(null);

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errorMsg) { }
    );
  }, []);
  useEffect(() => {
    if (
      !sessionStorage.getItem("manageUsers") ||
      sessionStorage.getItem("manageUsers") == 1
    ) {
      if (timeZone) {
        getAllRoles(
          (data) => {
            const filteredData = data?.map((rawData) => {
              const epochValue = rawData.createdOn;
              const outputDatetimeStr = convertIsoToGivenDateFormat(
                epochValue,
                timeZone
              );
              rawData["createdOn"] = outputDatetimeStr;

              return rawData;
            });
            setRolesData(filteredData);
            setLoading(false);
          },
          (errorMsg) => {
            customToast("error", "high", errorMsg);
            setLoading(false);
          }
        );
      }
    }
  }, [timeZone]);
  const editRoleData = (value) => {
    if (value?.id) {
      setEditing(true);
      setEditId(value);
    }
  };
  const deleteRoleData = (deleteId) => {
    setDeleteId(deleteId?.id);
  };

  useEffect(() => {
    if (deleteId && tableActionValue === "Delete Role" && editing) {
      setToggleDialog(true);
    }
  }, [deleteId, tableActionValue, editing]);
  const actionValue = (value) => {
    setTableActionValue(value);
  };

  useEffect(() => {
    if (editing && editId && tableActionValue === "Edit Role") {
      navigate("/settings/manageTeam/editRole?editRoleId=" + editId?.id, {
        state: { editing, editId },
      });
    }
  }, [editing, tableActionValue, editId]);

  useEffect(() => {
    if (editing && editId && tableActionValue === "View Details") {
      navigate("/settings/manageTeam/editRole?editRoleId=" + editId?.id, {
        state: { editing, editId },
      });
    }
  }, [editId, editing, tableActionValue]);

  const handleDeleteToggleBtn = () => {
    deleteRoleById(
      deleteId,
      function (data) {
        setDeleteId(null);
        getAllRoles(
          (data) => {
            const filteredData = data?.map((rawData) => {
              const epochValue = rawData?.createdOn;
              const outputDatetimeStr = convertIsoToGivenDateFormat(
                epochValue,
                timeZone
              );
              rawData["createdOn"] = outputDatetimeStr;

              return rawData;
            });
            setRolesData(filteredData);
            setToggleDialog(false);
            customToast("success", "high", "Role deleted successfully");
          },
          (errorMsg) => {
            customToast("error", "high", errorMsg);
            setLoading(false);
          }
        );
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };

  return (
    <>
      {loading ? (
        <div>
          <section
            className="content"
            style={{
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : (
        <section className="mainDivWebHooks">
          {rolesData?.length > 0 && (
            <>
              <ContentHeader
                firstHeading="Assign roles to your team members"
                secondHeading="Create user roles and assign it to the respective team members"
                buttonPermissions={[operationPermissions?.createRole]}
                icon={<GroupAddOutlinedIcon   sx={{color:colorBrandObject.sideBarSelectedOptionBackground}} />}
                buttonText="Create New Role"
                buttonType="primary"
                buttonSize="md"
                buttonVariant="contained"
                buttonOnclick={() =>
                  navigate("/settings/manageTeam/createRole")
                }
                showFabButton={true}
                handleFabClick={() =>
                  navigate("/settings/manageTeam/createRole")
                }
                fabButtonText="Create Link"
              />
              <div
                style={{ width: "100%", display: "flex", marginTop: "32px" }}
              >
                <BoxPayGrid
                  schema={RoleSchema(
                    deleteRoleData,
                    editRoleData,
                    actionValue,
                    operationPermissions
                  )}
                  data={rolesData}
                  showCustomizeButton={false}
                />
              </div>
              <SmallModal
                headerText={"Delete Role"}
                subHeaderText={"Are you sure you want to delete this role? "}
                outlinedBtnText={"Cancel"}
                filledBtnText={"Delete"}
                outlinedBtnFunction={() => {
                  setToggleDialog(false);
                  setEditing(false);
                }}
                filledBtnFunction={handleDeleteToggleBtn}
                toggleDialog={toggleDialog}
                icon={<img src="/assets/routingIcons/ExclamationCircle.svg" />}
              />
            </>
          )}
        </section>
      )}
    </>
  );
}
